import type { VariantItem, ProductLinkTarget, SanityProductVariantItem } from '../product-variant.types';
import { mapLink } from './map-link';
import { toImageField } from './map-image';

/**
 * Maps a Sanity product variant item to VariantItem
 */
export const mapItem = (raw: SanityProductVariantItem): VariantItem => {
  const v = raw.productVariant;

  // Determine which image to use: defaultImage, first from productVariant.image array, or placeholder
  const image: { asset: { url: string } } = raw.defaultImage
    ? toImageField(raw.defaultImage)
    : Array.isArray(v?.image) && v.image[0]
      ? toImageField(v.image[0])
      : toImageField(null);

  // Build product attribute string from options or use variantValue
  const productAttribute: string | undefined =
    Array.isArray(v?.options) && v.options.length > 0
      ? v.options
          .map((o) => {
            const parts: string[] = [];
            if (o.attribute?.name) parts.push(o.attribute.name);
            if (o.value || o.title) parts.push(o.value || o.title || '');
            return parts.filter(Boolean).join(': ');
          })
          .filter(Boolean)
          .join(', ')
      : raw.variantValue || undefined;

  // Check if variant has buttons and use the first active one as the link
  let variantLink: ProductLinkTarget | undefined;
  if (Array.isArray(v?.buttons) && v.buttons.length > 0) {
    const firstButton = v.buttons[0];
    if (firstButton?.isActive !== false && firstButton?.url) {
      variantLink = mapLink({
        _type: 'linkOptional',
        url: firstButton.url,
        isOpenInNewTab: firstButton.openInNewTab,
        type: 'internal',
      });
    }
  }

  return {
    heading: raw.name ?? '',
    subheading: raw.description || undefined,
    productAttribute,
    image,
    link: variantLink || mapLink(raw.campaignLink),
  };
};
